import React from 'react';

const Datenschutz: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
      <div className="bg-white shadow-lg rounded-lg p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Datenschutzerklärung</h1>
        
        <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Datenschutz auf einen Blick</h2>
            
            <h3 className="text-xl font-medium text-gray-800 mb-3">Allgemeine Hinweise</h3>
            <p>
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten 
              passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie 
              persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen 
              Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mb-3">Datenerfassung auf dieser Website</h3>
            <h4 className="text-lg font-medium text-gray-800 mb-2">Wer ist verantwortlich für die Datenerfassung auf dieser Website?</h4>
            <p>
              Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten 
              können Sie dem Abschnitt "Hinweis zur Verantwortlichen Stelle" in dieser Datenschutzerklärung entnehmen.
            </p>

            <h4 className="text-lg font-medium text-gray-800 mb-2">Wie erfassen wir Ihre Daten?</h4>
            <p>
              Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich 
              z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben.
            </p>
            <p>
              Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere 
              IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder 
              Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Hosting</h2>
            <p>
              Wir hosten die Inhalte unserer Website bei einem externen Dienstleister. Die personenbezogenen Daten, 
              die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert. Hierbei kann es 
              sich v. a. um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, 
              Namen, Websitezugriffe und sonstige Daten, die über eine Website generiert werden, handeln.
            </p>
            <p>
              Der Einsatz des Hosters erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen und 
              bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen und 
              effizienten Bereitstellung unseres Online-Angebots durch einen professionellen Anbieter (Art. 6 Abs. 1 lit. f DSGVO).
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Allgemeine Hinweise und Pflichtinformationen</h2>
            
            <h3 className="text-xl font-medium text-gray-800 mb-3">Datenschutz</h3>
            <p>
              Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre 
              personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzbestimmungen sowie 
              dieser Datenschutzerklärung.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mb-3">Hinweis zur verantwortlichen Stelle</h3>
            <p>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
            <div className="bg-gray-50 p-4 rounded-lg mt-2">
              <p><strong>Flugsportverein Otto Lilienthal Bad Langensalza e.V.</strong></p>
              <p>Thamsbrücker Landstraße 28</p>
              <p>99947 Bad Langensalza</p>
              <p>Telefon: +49 3603 895 8503</p>
              <p>E-Mail: info@flugsportverein.eu</p>
            </div>

            <h3 className="text-xl font-medium text-gray-800 mb-3">Speicherdauer</h3>
            <p>
              Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben 
              Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein 
              berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen, 
              werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung 
              Ihrer personenbezogenen Daten haben.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Datenerfassung auf dieser Website</h2>
            
            <h3 className="text-xl font-medium text-gray-800 mb-3">Server-Log-Dateien</h3>
            <p>
              Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, 
              die Ihr Browser automatisch an uns übermittelt. Dies sind:
            </p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Browsertyp und Browserversion</li>
              <li>verwendetes Betriebssystem</li>
              <li>Referrer URL</li>
              <li>Hostname des zugreifenden Rechners</li>
              <li>Uhrzeit der Serveranfrage</li>
              <li>IP-Adresse</li>
            </ul>
            <p>
              Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Die Erfassung dieser 
              Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes 
              Interesse an der technisch fehlerfreien Darstellung und der Optimierung seiner Website – hierzu müssen 
              die Server-Log-Files erfasst werden.
            </p>
            <p>
              <strong>Speicherdauer:</strong> Server-Log-Dateien werden für maximal 30 Tage gespeichert und anschließend 
              automatisch gelöscht, es sei denn, sie werden für die Aufklärung von Sicherheitsvorfällen benötigt.
            </p>

            <h3 className="text-xl font-medium text-gray-800 mb-3">Kontaktformular</h3>
            <p>
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular 
              inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall 
              von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
            </p>
            <p>
              Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage 
              mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen 
              erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse 
              an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO).
            </p>

            <h3 className="text-xl font-medium text-gray-800 mb-3">Petitionsformular (openPetition)</h3>
            <p>
              Diese Website nutzt das Petitionsformular der openPetition gemeinnützige GmbH, Am Friedrichshain 34, 
              10407 Berlin. Die openPetition gemeinnützige GmbH stellt die technische Plattform für die Sammlung 
              von Petitionsunterschriften zur Verfügung.
            </p>
            <p>
              Die von Ihnen bei der Petition eingegebenen Daten (z.B. Name, Adresse, Kommentar) werden von openPetition 
              zur Gewährleistung der Petition auf Servern in Deutschland gespeichert und verarbeitet. Bei jedem 
              Seitenaufruf der Petitionsseite werden Browser-Informationen (z.B. Browser-Typ, Betriebssystem, IP-Adresse, 
              Uhrzeit und der Referrer) gespeichert. Die Logfiles werden statistisch ausgewertet und helfen, den 
              fehlerfreien Betrieb der Seiten sicherzustellen.
            </p>
            <p>
              Es gelten die Datenschutzbestimmungen von openPetition:{' '}
              <a href="https://www.openpetition.de/content/data_privacy" className="text-primary hover:text-primary-dark underline" target="_blank" rel="noopener noreferrer">
                https://www.openpetition.de/content/data_privacy
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Analyse-Tools und Werbung</h2>
            
            <h3 className="text-xl font-medium text-gray-800 mb-3">Google Analytics</h3>
            <p>
              Diese Website nutzt Funktionen des Webanalysedienstes Google Analytics. Anbieter ist die Google Ireland 
              Limited ("Google"), Gordon House, Barrow Street, Dublin 4, Irland.
            </p>
            <p>
              Google Analytics ermöglicht es dem Websitebetreiber, das Verhalten der Websitebesucher zu analysieren. 
              Hierbei erhält der Websitebetreiber verschiedene Nutzungsdaten, wie z. B. Seitenaufrufe, Verweildauer, 
              verwendete Betriebssysteme und Herkunft des Nutzers. Diese Daten werden von Google ggf. in einem Profil 
              zusammengefasst, das dem jeweiligen Nutzer bzw. dessen Endgerät zugeordnet ist.
            </p>
            <p>
              Google Analytics verwendet Technologien, die die Wiedererkennung des Nutzers zum Zwecke der Analyse des 
              Nutzerverhaltens ermöglichen (z. B. Cookies oder Device-Fingerprinting). Die von Google erfassten 
              Informationen über die Benutzung dieser Website werden in der Regel an einen Server von Google in den 
              USA übertragen und dort gespeichert.
            </p>
            <p>
              Die Nutzung dieses Analyse-Tools erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber 
              hat ein berechtigtes Interesse an der Analyse des Nutzerverhaltens, um sowohl sein Webangebot als auch 
              seine Werbung zu optimieren. Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die 
              Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TTDSG.
            </p>
            
            <h4 className="text-lg font-medium text-gray-800 mb-2">IP-Anonymisierung</h4>
            <p>
              Wir haben auf dieser Website die Funktion IP-Anonymisierung aktiviert. Dadurch wird Ihre IP-Adresse von 
              Google innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens 
              über den Europäischen Wirtschaftsraum vor der Übermittlung in die USA gekürzt.
            </p>

            <h4 className="text-lg font-medium text-gray-800 mb-2">Browser Plugin</h4>
            <p>
              Sie können die Erfassung und Verarbeitung Ihrer Daten durch Google verhindern, indem Sie das unter dem 
              folgenden Link verfügbare Browser-Plugin herunterladen und installieren: 
              <a href="https://tools.google.com/dlpage/gaoptout?hl=de" className="text-primary hover:text-primary-dark underline" target="_blank" rel="noopener noreferrer">
                https://tools.google.com/dlpage/gaoptout?hl=de
              </a>
            </p>

            <h4 className="text-lg font-medium text-gray-800 mb-2">Widerspruch gegen Datenerfassung</h4>
            <p>
              Sie können die Erfassung Ihrer Daten durch Google Analytics verhindern, indem Sie auf folgenden Link klicken. 
              Es wird ein Opt-Out-Cookie gesetzt, der die Erfassung Ihrer Daten bei zukünftigen Besuchen dieser Website verhindert:
            </p>
            <p>
              <a href="#" className="text-primary hover:text-primary-dark underline" onClick={(e) => {
                e.preventDefault();
                // Hier würde der Google Analytics Opt-Out Code eingefügt
                alert('Google Analytics wurde deaktiviert.');
              }}>
                Google Analytics deaktivieren
              </a>
            </p>

            <p>
              Mehr Informationen zum Umgang mit Nutzerdaten bei Google Analytics finden Sie in der Datenschutzerklärung 
              von Google: 
              <a href="https://policies.google.com/privacy?hl=de" className="text-primary hover:text-primary-dark underline" target="_blank" rel="noopener noreferrer">
                https://policies.google.com/privacy?hl=de
              </a>
            </p>

            <h3 className="text-xl font-medium text-gray-800 mb-3">Facebook</h3>
            <p>
              Auf dieser Website sind Funktionen des sozialen Netzwerks Facebook integriert. Anbieter dieser Funktionen 
              ist die Meta Platforms Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland. 
              Die erfassten Daten werden nach Aussage von Facebook jedoch auch in die USA und in andere Drittländer übertragen.
            </p>

            <h4 className="text-lg font-medium text-gray-800 mb-2">Facebook Pixel</h4>
            <p>
              Diese Website nutzt zur Konversionsmessung das Besucheraktions-Pixel von Facebook. Anbieter dieses Dienstes 
              ist die Meta Platforms Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland. 
              Die erfassten Daten werden nach Aussage von Facebook jedoch auch in die USA und in andere Drittländer übertragen.
            </p>
            <p>
              So kann das Verhalten der Seitenbesucher nachverfolgt werden, nachdem diese durch Klick auf eine Facebook-Werbeanzeige 
              auf die Website des Anbieters weitergeleitet wurden. Dadurch können die Wirksamkeit der Facebook-Werbeanzeigen 
              für statistische und Marktforschungszwecke ausgewertet werden und zukünftige Werbemaßnahmen optimiert werden.
            </p>
            <p>
              Die erhobenen Daten sind für uns als Betreiber dieser Website anonym, wir können keine Rückschlüsse auf die 
              Identität der Nutzer ziehen. Die Daten werden aber von Facebook gespeichert und verarbeitet, sodass eine 
              Verbindung zum jeweiligen Nutzerprofil möglich ist und Facebook die Daten für eigene Werbezwecke, entsprechend 
              der Facebook-Datenverwendungsrichtlinie verwenden kann.
            </p>
            <p>
              Die Nutzung von Facebook Pixel erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber 
              hat ein berechtigtes Interesse an effektiven Werbemaßnahmen unter Einschluss der sozialen Medien. Sofern 
              eine entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage von 
              Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TTDSG.
            </p>

            <h4 className="text-lg font-medium text-gray-800 mb-2">Facebook Seiten</h4>
            <p>
              Wir betreiben eine Fanpage auf Facebook. Anbieter ist die Meta Platforms Ireland Limited, 4 Grand Canal Square, 
              Grand Canal Harbour, Dublin 2, Irland.
            </p>
            <p>
              Facebook erhält über die Facebook-Komponente immer dann eine Information darüber, dass Sie unsere Internetseite 
              besucht haben, wenn Sie zum Zeitpunkt des Aufrufs unserer Internetseite gleichzeitig bei Facebook eingeloggt sind. 
              Dies findet unabhängig davon statt, ob Sie die Facebook-Komponente anklicken oder nicht. Ist eine derartige 
              Übermittlung dieser Informationen an Facebook von Ihnen nicht gewollt, können Sie diese dadurch verhindern, 
              dass Sie sich vor einem Aufruf unserer Internetseite aus Ihrem Facebook-Account ausloggen.
            </p>
            <p>
              Wir sind gemeinsam mit Facebook Ireland für die Datenverarbeitung verantwortlich. Die Aufteilung der 
              datenschutzrechtlichen Verantwortlichkeiten wurde in einer Vereinbarung zwischen uns und Facebook Ireland 
              festgehalten. Diese Vereinbarung können Sie unter folgendem Link einsehen: 
              <a href="https://www.facebook.com/legal/terms/page_controller_addendum" className="text-primary hover:text-primary-dark underline" target="_blank" rel="noopener noreferrer">
                https://www.facebook.com/legal/terms/page_controller_addendum
              </a>
            </p>
            <p>
              Die Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse 
              liegt in der Analyse, der Kommunikation mit Besuchern, Kunden und Interessenten.
            </p>

            <h4 className="text-lg font-medium text-gray-800 mb-2">Widerspruch gegen Datenerfassung</h4>
            <p>
              Sie können Ihre Privatsphäre-Einstellungen bei Facebook anpassen, um Werbeanzeigen zu kontrollieren. 
              Besuchen Sie dazu die Facebook-Seite: 
              <a href="https://www.facebook.com/settings?tab=ads" className="text-primary hover:text-primary-dark underline" target="_blank" rel="noopener noreferrer">
                https://www.facebook.com/settings?tab=ads
              </a>
            </p>

            <p>
              Mehr Informationen zur Datenverarbeitung durch Facebook finden Sie in der Datenschutzerklärung von Facebook: 
              <a href="https://www.facebook.com/about/privacy/" className="text-primary hover:text-primary-dark underline" target="_blank" rel="noopener noreferrer">
                https://www.facebook.com/about/privacy/
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Ihre Rechte</h2>
            <p>Sie haben folgende Rechte:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Recht auf Auskunft:</strong> Sie können Auskunft über Ihre von uns verarbeiteten personenbezogenen Daten verlangen.</li>
              <li><strong>Recht auf Berichtigung:</strong> Sie haben ein Recht auf Berichtigung unrichtiger oder auf Vervollständigung richtiger Daten.</li>
              <li><strong>Recht auf Löschung:</strong> Sie können die Löschung Ihrer personenbezogenen Daten verlangen.</li>
              <li><strong>Recht auf Einschränkung:</strong> Sie können die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten verlangen.</li>
              <li><strong>Recht auf Datenübertragbarkeit:</strong> Sie haben das Recht, Ihre Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten.</li>
              <li><strong>Widerspruchsrecht:</strong> Sie können der Verarbeitung Ihrer personenbezogenen Daten widersprechen.</li>
              <li><strong>Recht auf Beschwerde:</strong> Sie haben das Recht, sich bei einer Aufsichtsbehörde zu beschweren.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. SSL- bzw. TLS-Verschlüsselung</h2>
            <p>
              Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum 
              Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL- bzw. 
              TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers 
              von "http://" auf "https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
            </p>
          </section>

          <section className="bg-gray-50 p-6 rounded-lg">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Kontakt bei Datenschutzfragen</h2>
            <p>
              Bei Fragen zum Datenschutz wenden Sie sich bitte an:
            </p>
            <div className="mt-3">
              <p><strong>Flugsportverein Otto Lilienthal Bad Langensalza e.V.</strong></p>
              <p>E-Mail: info@flugsportverein.eu</p>
              <p>Telefon: +49 3603 895 8503</p>
            </div>
          </section>

          <div className="text-sm text-gray-500 mt-8 pt-4 border-t">
            <p>Stand: {new Date().toLocaleDateString('de-DE')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Datenschutz; 